import React from 'react';
import { NeoGrid } from '@singularsystems/neo-react';
import { observer } from 'mobx-react';
import { DateCycleEditComponent } from './DateCycleEdit';
import DateCyclesVM from '../DateCyclesVM';

export interface IDateCycleListComponentProps {
    viewModel: DateCyclesVM;
}

@observer
export class DateCycleListComponent extends React.Component<IDateCycleListComponentProps> {

    public render() {
        const { viewModel } = this.props;

        if (viewModel.editingDateCycle) {
            return <DateCycleEditComponent viewModel={viewModel} />
        } else {
            return this.renderDateCycleList(viewModel);
        }
    }

    public renderDateCycleList(viewModel: DateCyclesVM) {

        return (
            <NeoGrid.Grid items={viewModel.dateCycleList} addButton={{onClick: () => viewModel.newDateCycle()}}>
                {(item, meta) => (
                    <NeoGrid.Row>
                        <NeoGrid.Column display={meta.name} />
                        <NeoGrid.Column display={meta.description} />
                        <NeoGrid.Column display={meta.ordinal} />
                        <NeoGrid.ButtonColumn
                            editButton={{onClick: () => viewModel.beginEditDateCycle(item.dateCycleId, item.isLinkedToInvestment)}}
                            deleteButton={{ disabled: item.isLinkedToInvestment, onClick: () => viewModel.deleteDateCycle(item) }} />
                    </NeoGrid.Row>
                )}
            </NeoGrid.Grid>
        )
    }
}